export const CHANGE_SEARCH_FIELD = 'CHANGE_SEARCH_FIELD'
export const CATS_INFO_FETCHED = 'CATS_INFO_FETCHED'
export const CATS_INFO_FETCH_ERROR = 'CATS_INFO_FETCH_ERROR'